import {
  Step,
  Stepper,
  StepperProvider,
  useStepper,
} from '@/components/Molecules/Stepper'
import { buildPath, Params, RouteKey } from '@/routes'
import { PropsWithChildren, useMemo } from 'react'
import { Outlet, useParams } from 'react-router'

// TODO: Move to providers/hooks folder
export const BrokerSteps = [
  {
    title: 'Signup',
    description: 'Provide your email and create a password',
    path: '/applications/certificate/:applicationId/broker',
  },
  {
    title: 'Review SAFER',
    description: 'Review your SAFER report for accuracy',
    path: '/applications/certificate/:applicationId/broker/review-safer',
  },
  {
    title: 'Broker Documents',
    description: 'Upload the necessary documents for your broker application',
    path: '/applications/certificate/:applicationId/broker/documents',
  },
  {
    title: 'Broker Application Complete',
    description: 'Your broker application has been submitted successfully.',
    path: '/applications/certificate/:applicationId/broker/complete',
  },
] as const satisfies Partial<Step & { path: RouteKey }>[]

export function BrokerStepsProvider({ children }: PropsWithChildren) {
  const { applicationId } =
    useParams<Params<'/applications/certificate/:applicationId/broker'>>()

  // Memoize once
  const orderedSteps = useMemo(
    () => resolveSteps(applicationId!),
    [applicationId] // Memoize once
  )

  return (
    <StepperProvider steps={orderedSteps}>
      <Stepper
        allComplete={buildPath(
          '/applications/certificate/:applicationId/broker/complete',
          { applicationId: applicationId! }
        )}
      />
      {children || <Outlet />}
    </StepperProvider>
  )
}

const resolveSteps = (applicationId: string) =>
  BrokerSteps.map((step) => ({
    ...step,
    path: buildPath(step.path, { applicationId }),
  }))

export function useBrokerSteps(applicationId: string) {
  const orderedSteps = useMemo(
    () => resolveSteps(applicationId),
    [applicationId] // Memoize once
  )

  return useStepper<typeof orderedSteps>()
}
